import React from 'react'
import './Numbers.sass'
import SectionTitle from '../../ui/SectionTitle/SectionTitle'

import av1 from './assets/1/av.jpg'
import img11 from './assets/1/1.jpg'
import img12 from './assets/1/2.jpg'
import img13 from './assets/1/3.jpg'
import img14 from './assets/1/4.jpg'

import av2 from './assets/2/av.jpg'
import img21 from './assets/2/1.jpg'
import img22 from './assets/2/2.jpg'
import img23 from './assets/2/3.jpg'
import img24 from './assets/2/4.jpg'
import img25 from './assets/2/5.jpg'

import av3 from './assets/3/av.jpg'
import img31 from './assets/3/1.jpg'
import img32 from './assets/3/2.jpg'
import img33 from './assets/3/3.jpg'

import Button from '../../ui/Button/Button'

import obj1 from './assets/obj1.svg'
import obj2 from './assets/obj2.svg'
import { withRouter } from 'react-router-dom'
import Icon from '../../ui/Icon/Icon'

function Numbers({ ...router }) {
  const data = [
    {
      id: '317217',
      avatar: av1,
      photos: [img11, img12, img13, img14],
      title: 'Эконом',
      description:
        'Просторные номера с возможностью размещения до 4х человек. Раздельные комфортные кровати. Санузел и оборудованная кухня в шаговой доступности на этаже.',
      counter: 15,
      price: 500,
    },
    {
      id: '313684',
      avatar: av2,
      photos: [img21, img22, img23, img24, img25],
      title: 'Стандарт',
      description:
        'Номер Стандарт, с возможностью размещения до 4х человек, гигиенические принадлежности, чайная станция, смарт тв, wi -fi, комфортные кровати, которые можно компоновать как отдельно , так и соединить. Санузел, душевая и оборудованная кухня в шаговой доступности на этаже.',
      counter: 3,
      price: 600,
    },
    {
      id: '313654',
      avatar: av3,
      photos: [img31, img32, img33],
      title: 'Семейный',
      description:
        'Просторный двухкомнатный номер . В номере: гигиенические принадлежности,чайная станция,смарт -тв,wi-fi. комфортные кровати, которые можно компоновать как отдельно, так и соединить. В номере возможно проживание до 4х человек. Санузел, душевая и оборудованная кухня в шаговой доступности на этаже.',
      counter: 1,
      price: 1000,
    },
  ]
  return (
    <section
      id="numbers"
      className="Numbers"
      style={{ backgroundImage: `url(${obj1}), url(${obj2})` }}
    >
      <div className="DefaultContainer">
        <SectionTitle title="Наши номера" />
        <div className="Numbers-Container">
          <div className="Text">
            <b>Удобства, доступные вне зависимости от типа номера:</b> <br />
            Регистрация по месту перебывания от 4-ех дней проживания, общая
            кухня, оборудованная посудой, чайниками, холодильниками,
            микроволновыми печами, а также варочными плитами
            <br />
            Телевизор
            <br />
            Wi-Fi
            <br /> Бесплатное проживание с животными
            <br /> Бесплатная камера хранения
            <br /> Ежедневная уборка номера
            <br />
            <br />
            <b>По запросу</b>
            <br />
            Детские принадлежности
            <br />
            Утюг и гладильная доска
            <br />
            <br />
            <b>А также:</b>
            <br /> Заказ такси
            <br />
            Бесплатная парковка с видеонаблюдением
          </div>
          <div className="Numbers-Tiles">
            {data.map((d) => (
              <NumberTile key={d.id} {...d} />
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

function NumberTile({ id, photos, avatar, title, description, counter }) {
  return (
    <div className="NumberTile">
      <div className="Avatar">
        <a href={avatar} data-fancybox={title}>
          <img src={avatar} alt={title} />
        </a>
        <div className="HiddenPhotos">
          {photos.map((p) => (
            <a href={p} data-fancybox={title}>
              <img src={p} alt={title} />
            </a>
          ))}
        </div>
      </div>
      <div className="Content">
        <p className="Title">{title}</p>
        <p className="Description">{description}</p>
        <ParamData title="Кол-во номеров" value={counter} />
        {/* <div className="PriceBlock">
          <p className="Label">Цена от</p>
          <span className="Bolder">1000 ₽</span>/ сутки
        </div> */}
        <a
          href={`/booking?room-type=${id}`}
          className="Button Button_theme_primary Button_size_48 Button-State_default"
        >
          <div class="Button-Content Button_icon_position_left">
            <span class="Button-IconContainer">
              <Icon name="calendar-alt" weight={'solid'} />
            </span>
            <span class="Button-Child Button-Bold">Забронировать номер</span>
          </div>
        </a>
      </div>
    </div>
  )
}

export function ParamData({ title, value }) {
  return (
    <li className="ParamData">
      <span className="ParamTitle">{title}</span>
      <span className="ParamDevider">&nbsp;</span>
      <span className="ParamValue">{value}</span>
    </li>
  )
}

export default withRouter(Numbers)
